import { Camera } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="contact" className="section-shell relative pb-12 pt-24">
      <div className="container relative mx-auto px-6">
        <div className="overflow-hidden rounded-[2.2rem] border border-white/60 bg-[linear-gradient(180deg,rgba(255,255,255,0.78),rgba(245,236,230,0.94))] p-8 shadow-card md:p-10">
          <div className="grid gap-10 md:grid-cols-[1.2fr_0.8fr_0.8fr_0.8fr]">
            <div>
              <div className="mb-4 flex items-center space-x-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full gradient-brand shadow-glow">
                  <div className="h-3 w-3 rounded-full bg-white" />
                </div>
                <span className="font-display text-2xl text-foreground">Ma Photo en Tableau</span>
              </div>
              <p className="max-w-sm text-sm leading-7 text-foreground/64">
                Transformez vos photos en œuvres d'art à exposer.
              </p>
              <div className="mt-6">
                <a href="#" className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/70 text-foreground/50 transition-smooth hover:text-primary">
                  <Camera className="h-5 w-5" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-foreground/42">Produit</h4>
              <ul className="space-y-3 text-sm text-foreground/62">
                <li><Link to="/photo-en-tableau" className="transition-smooth hover:text-primary">Photo en tableau</Link></li>
                <li><Link to="/tableau-photo-personnalise" className="transition-smooth hover:text-primary">Tableau photo personnalisé</Link></li>
                <li><Link to="/idees-cadeaux-photo-personnalises" className="transition-smooth hover:text-primary">Idées cadeaux photo</Link></li>
                <li><Link to="/portrait-animal-personnalise" className="transition-smooth hover:text-primary">Portrait animal personnalisé</Link></li>
                <li><a href="#gallery" className="transition-smooth hover:text-primary">Styles artistiques</a></li>
                <li><Link to="/styles/watercolor" className="transition-smooth hover:text-primary">Tableau aquarelle</Link></li>
                <li><Link to="/styles/oil-painting" className="transition-smooth hover:text-primary">Peinture à l&apos;huile</Link></li>
                <li><Link to="/styles/disney" className="transition-smooth hover:text-primary">Animation 3D</Link></li>
                <li><a href="#pricing" className="transition-smooth hover:text-primary">Formats disponibles</a></li>
                <li><a href="#process" className="transition-smooth hover:text-primary">Parcours de création</a></li>
                <li><Link to="/blog" className="transition-smooth hover:text-primary">Blog</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-foreground/42">Support</h4>
              <ul className="space-y-3 text-sm text-foreground/62">
                <li><a href="#contact" className="transition-smooth hover:text-primary">Contact</a></li>
                <li><a href="/auth" className="transition-smooth hover:text-primary">Connexion</a></li>
              </ul>
            </div>

            <div>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-foreground/42">Légal</h4>
              <ul className="space-y-3 text-sm text-foreground/62">
                <li><a href="/cgv" className="transition-smooth hover:text-primary">CGV</a></li>
                <li><a href="/politique-confidentialite" className="transition-smooth hover:text-primary">Politique de confidentialité</a></li>
                <li><a href="/mentions-legales" className="transition-smooth hover:text-primary">Mentions légales</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-8 border-t border-foreground/10 pt-8 text-center">
            <p className="text-sm text-foreground/46">© 2026 Ma Photo en Tableau. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
